import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["href", "leftIcon", "rightIcon", "children", "className", "color", "size", "width", "openModel"];
import clsx from "clsx";
import React from "react";
import NextLink from "next/link";
import { createMemoClass } from "../create-memo-class";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    href,
    leftIcon,
    rightIcon,
    children,
    className,
    color,
    size = "md",
    width = "auto",
    openModel
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = useButtonClass({
    color,
    size,
    width
  });

  var Components = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [leftIcon ? leftIcon : null, /*#__PURE__*/_jsx("span", {
      className: "max-w-full text-ellipsis overflow-hidden",
      children: children
    }), rightIcon ? rightIcon : null]
  });

  var hrefString = typeof href === "string" ? href : href == null ? void 0 : href.cached_url;
  var router = useRouter();

  if (openModel) {
    return /*#__PURE__*/_jsx("button", _extends({
      ref: ref,
      onClick: openModel,
      className: clsx(classes, className)
    }, rest, {
      children: /*#__PURE__*/_jsx(Components, {})
    }));
  } else if (hrefString && !router.query.preview) {
    if (hrefString != null && hrefString.startsWith("http") || hrefString != null && hrefString.startsWith("www") || hrefString != null && hrefString.startsWith("#")) return /*#__PURE__*/_jsx("a", {
      className: clsx(classes, className),
      href: hrefString,
      children: /*#__PURE__*/_jsx(Components, {})
    });
    return /*#__PURE__*/_jsx(NextLink, {
      href: hrefString || "/",
      passHref: true,
      children: /*#__PURE__*/_jsx("a", {
        className: clsx(classes, className),
        children: /*#__PURE__*/_jsx(Components, {})
      })
    });
  }

  return /*#__PURE__*/_jsx("button", _extends({
    ref: ref,
    className: clsx(classes, className)
  }, rest, {
    children: /*#__PURE__*/_jsx(Components, {})
  }));
});
export var useButtonClass = createMemoClass(props => {
  var widths = {
    auto: "w-auto",
    full: "w-full",
    "fit-content": "w-fit"
  };
  var colors = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    tertiary: "btn-tertiary",
    neutral: "btn-neutral",
    transparent: "btn-transparent"
  };
  var sizes = {
    xs: "btn-xs",
    sm: "btn-sm",
    md: "btn-md",
    lg: "btn-lg",
    xl: "btn-xl"
  };
  var classes = clsx("btn", sizes[props.size], colors[props.color], widths[props.width]);
  return classes;
});
//# sourceMappingURL=button.js.map